import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ManualDataUpdateRoutingModule} from './manual-data-update-routing.module';
import {ManualDataUpdateComponent} from './manual-data-update.component';
import {FormsModule} from '@angular/forms';
import {DxDataGridModule, DxChartModule, DxBulletModule, DxTemplateModule, DxDateBoxModule, DxPopupModule, DxTextAreaModule, DxFileUploaderModule, DxLoadPanelModule, DxProgressBarModule} from 'devextreme-angular';
import {DevEpressCommonModule} from 'src/app/dev-epress-common.module';
import {TaskPopupModule} from '../../task/task-popup/task-popup.module';
import {DxTableControllerDirective} from 'src/app/directives/dx-table-controller.directive';

@NgModule({
	declarations: [
		ManualDataUpdateComponent,
	],
	imports: [
		CommonModule,

		ManualDataUpdateRoutingModule,

		DxDataGridModule,
		DxChartModule,
		DevEpressCommonModule,
		DxDataGridModule,
		DxBulletModule,
		DxTemplateModule,
		TaskPopupModule,
		DxDateBoxModule,
		DxPopupModule,
		DxTextAreaModule,
		DxFileUploaderModule,
		FormsModule,
		DxLoadPanelModule,
		DxProgressBarModule,
		DxPopupModule,
		DxTextAreaModule,
		DxTableControllerDirective,
	],
})
export class ManualDataUpdateModule { }